import React from 'react';
import { Star, Sparkles } from 'lucide-react';

/**
 * Valoración de un profesional, dicha con honestidad.
 *
 * Mientras nadie lo haya evaluado, el sistema guarda un 5.0 por defecto. Pintar
 * ese número como si fuera una nota real es inventar prueba social: quien recién
 * llega se muestra como "Nuevo", no con cinco estrellas que nadie le dio.
 */
export const Valoracion = ({ rating, cantidad, sesiones, className = '' }) => {
  const tieneValoraciones = Number(cantidad) > 0;

  if (!tieneValoraciones) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <span className="inline-flex items-center gap-1.5 text-sm text-teal-700 bg-teal-50 px-2.5 py-0.5 rounded-full">
          <Sparkles className="w-3.5 h-3.5" />
          Nuevo en la plataforma
        </span>
        {Number(sesiones) > 0 && (
          <>
            <span className="text-slate-400" aria-hidden="true">•</span>
            <span className="text-sm text-slate-500">{sesiones} sesiones</span>
          </>
        )}
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="flex items-center gap-1">
        <Star className="w-4 h-4 fill-amber-400 text-amber-400" />
        <span className="text-sm font-medium text-slate-700">{Number(rating).toFixed(1)}</span>
      </span>
      <span className="text-sm text-slate-500">
        ({cantidad} {Number(cantidad) === 1 ? 'valoración' : 'valoraciones'})
      </span>
      {Number(sesiones) > 0 && (
        <>
          <span className="text-slate-400" aria-hidden="true">•</span>
          <span className="text-sm text-slate-500">{sesiones} sesiones</span>
        </>
      )}
    </div>
  );
};

export default Valoracion;
